export const APPLICATION_JSON = 'application/json';
export const CONTENT_TYPE = 'Content-Type';
export const ACCESS_TOKEN = 'Access-Token';
export const UID = 'uid';
export const CLIENT = 'client';
